import {  AttachmentUpdateBody } from "../../../../page-controller-mod/page-serv/settings/workflow-set/ts/setting-attachment.type";
import { SettingChange } from "./settings-draft.context";

export const buildAttachmentPayload = (changes: SettingChange[]): AttachmentUpdateBody => {
  const body: AttachmentUpdateBody = {};

  for (const c of changes) {
    if (c.pageKey !== "attachments") continue;
    if (c.type !== "input") continue;

    // Group 1 item 1 => maxSizeMb
    if (c.groupId === 1 && c.itemId === 1) {
      // accept "5", "5 MB", " 5mb "
      const raw = String(c.value).trim().toLowerCase().replace("mb", "").trim();
      const num = Number(raw);

      if (!Number.isFinite(num)) continue; // skip invalid
      body.maxSizeMb = num;
    }
  }

  return body;
};